import * as Html from "../util/Html.ts";
export {initDom,destroyDom}
Html.registerWidget('widget/endintoview',{initDom:initDom,destroyDom:destroyDom})

function crawlForScrollable(el: HTMLElement): HTMLElement | null {
  let parent = el.parentElement;
  while(parent && parent !== document.body) {
    const style = getComputedStyle(parent);
    if(['scroll', 'auto', 'overlay'].indexOf(style.overflowY) > -1) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return document.body; // fallback to body if no scrollable parent found
}

function visible_in_container(container: HTMLElement, element: HTMLElement): boolean {
  try {
    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    // Check style visibility and off-limits
    return !(elementRect.top > containerRect.bottom || elementRect.bottom < containerRect.top);
  } catch(err) {
    return false;
  }
}

function isVisible(element: HTMLElement): boolean {
  // Check if element is visible (not display:none)
  return element.offsetParent !== null || element === document.body;
}

function handle(scrollable: HTMLElement, element: HTMLElement) {
  if(isVisible(element) && visible_in_container(scrollable, element)) {
    const intervalId = element.getAttribute('data-interval');
    if(intervalId) {
      clearInterval(Number(intervalId));
      element.removeAttribute('data-interval');
    }
    // Déclencher l'événement personnalisé 'endintoview'
    const event = new CustomEvent('endintoview', {
      detail: element,
      bubbles: true
    });
    element.dispatchEvent(event);
  }
}

function initDom(element: HTMLElement) {
  const scrollable = crawlForScrollable(element);
  if(!scrollable) return;

  const intervalId = setInterval(function() {
    handle(scrollable, element);
  }, 350);

  // Stocker l'ID de l'intervalle dans un attribut data
  element.setAttribute('data-interval', intervalId.toString());
}

function destroyDom(element: HTMLElement) {
  const intervalId = element.getAttribute('data-interval');
  if(intervalId) {
    clearInterval(Number(intervalId));
    element.removeAttribute('data-interval');
  }
}